import { render } from "./PlanetaryPositionsPanchanga.vue?vue&type=template&id=e746a366&scoped=true"
import script from "./PlanetaryPositionsPanchanga.vue?vue&type=script&lang=js"
export * from "./PlanetaryPositionsPanchanga.vue?vue&type=script&lang=js"

import "./PlanetaryPositionsPanchanga.vue?vue&type=style&index=0&id=e746a366&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2623155984/src/jamakkol-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e746a366"]])

export default __exports__